(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["td-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Global object to track timers across section re-renders
    window.tdAnnouncementTimers = window.tdAnnouncementTimers || {};

    // Get DOM elements with null checks
    var announcementBarEl = document.querySelector('[data-announcement-bar-id]');
    var timerDateEl = document.querySelector('[data-announcement-bar-timer-date]');

    // Only initialize if dependent elements present
    if (!announcementBarEl || !timerDateEl) {
      return;
    }

    var currentSectionId = announcementBarEl.getAttribute('data-announcement-bar-id');
    var timerDate = timerDateEl.getAttribute('data-announcement-bar-timer-date');

    // Exit early if required data attributes are missing
    if (!currentSectionId || !timerDate) {
      return;
    }

    // Clear existing timer for this section if it exists
    if (window.tdAnnouncementTimers[currentSectionId]) {
      clearInterval(window.tdAnnouncementTimers[currentSectionId]);
    }

    // Set the date we're counting down to
    var countDownDate = new Date(timerDate).getTime();

    // Exit if the date is invalid
    if (isNaN(countDownDate)) {
      return;
    }

    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for hours, minutes and seconds
      var hours = Math.floor(distance / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Format with leading zeros
      var hoursStr = hours < 10 ? '0' + hours : hours;
      var minutesStr = minutes < 10 ? '0' + minutes : minutes;
      var secondsStr = seconds < 10 ? '0' + seconds : seconds;

      var sectionSelector = '.section-' + currentSectionId;
      var hoursEls = document.querySelectorAll(sectionSelector + ' .timer-h');
      var minutesEls = document.querySelectorAll(sectionSelector + ' .timer-m');
      var secondsEls = document.querySelectorAll(sectionSelector + ' .timer-s');

      hoursEls.forEach(function (el) {
        el.innerHTML = hoursStr;
      });
      minutesEls.forEach(function (el) {
        el.innerHTML = minutesStr;
      });
      secondsEls.forEach(function (el) {
        el.innerHTML = secondsStr;
      });

      // If the count down is finished, clear the interval
      if (distance < 0) {
        clearInterval(x);
      }
    }, 1000);

    // Store the new timer ID
    window.tdAnnouncementTimers[currentSectionId] = x;
  })();

  } catch(e) { console.error(e); }
})();
})();
